import styles from "./requestDetails.module.css";

import { useAuth0 } from "@auth0/auth0-react";
import RequestResolution from "./RequestResolution";
function RequestSummary({
  isPanelOpen,
  onToggle,
  maintenanceDetails,
  togglePanel,
}) {
  const { user } = useAuth0();

  return (
    <div className={`${styles.AccordionList}`}>
      <div
        className={`${styles.AccordionListHead} ${
          isPanelOpen ? styles.Open : ""
        }`}
        onClick={onToggle}
      >
        <p className={`${styles.Title}`}>Request</p>
        <img src="/static/img/downTriangle.svg" />
      </div>
      <div
        className={`${styles.AccordionListBody} ${
          isPanelOpen ? styles.Open : ""
        }`}
      >
        <p className={`${styles.SummaryDetails}`}>
          {maintenanceDetails?.description}
        </p>

        <div className={`${styles.ReqDeAddBodyFile}`}>
          <p className={`${styles.FileTitle}`}>Images</p>
          {maintenanceDetails?.images?.length > 0 &&
            maintenanceDetails?.images?.map((img) => {
              return (
                <div className={`${styles.AddFormFileUP}`} key={img.id}>
                  <img
                    src={img?.file_public_url}
                    className={`${styles.UpIMG}`}
                  />
                </div>
              );
            })}
          {maintenanceDetails?.images?.length === 0 && (
            <div className={`${styles.NoImgDiv}`}>
              <img src="/static/img/no-photo.png" />
            </div>
          )}
        </div>

        {!maintenanceDetails?.resolution &&
          user?.["https://propertydek.com/permissions"]?.includes(
            "request-technician:update"
          ) && (
            <button
              className={`${styles.ResolveBU}`}
              onClick={() => togglePanel("resolution")}
            >
              Resolve
            </button>
          )}
      </div>
    </div>
  );
}

export default RequestSummary;
